import { createStore } from './createStore';
import { reducer } from './reducer';

const appStore = createStore(reducer, { isReady: false });

export { appStore };
